import Image from 'next/image'

import { avatarAssets } from '@lib/avatar'
import { cn } from '@lib/cn'

interface SeededAvatarProps {
  seed: string
  image?: string | null
  size: number
  priority?: boolean
  className?: string
}

const SeededAvatar = ({ seed, image, size, priority = false, className }: SeededAvatarProps) => {
  const assets = avatarAssets(seed)
  const alt = `${seed}'s avatar`

  return (
    <div
      className={cn('relative flex shrink-0 select-none items-center justify-center overflow-hidden rounded-md bg-white', className)}
      style={{ width: size, height: size }}
    >
      {image && <Image fill src={image} alt={alt} unoptimized priority={priority} className="object-cover" />}
      {!image && assets.letter && (
        <Image aria-hidden alt="" src={assets.letter} width={size * 0.5} height={size * 0.5} priority={priority} className="z-10" />
      )}
      {!image && !assets.letter && (
        <span className="z-10 font-semibold leading-none text-white" style={{ fontSize: size * 0.5 }}>
          {assets.fallbackLetter}
        </span>
      )}
      {!image && (
        <Image fill alt={alt} src={assets.background} priority={priority} className="z-0 object-cover dark:brightness-90" />
      )}
    </div>
  )
}

interface UserAvatarProps {
  email?: string | null
  name?: string | null
  image?: string | null
  size?: number
  priority?: boolean
  className?: string
}

export const UserAvatar = ({ email, name, image, size = 24, priority, className }: UserAvatarProps) => {
  const seed = name || email

  if (!seed) return <div style={{ width: size, height: size }} />

  return <SeededAvatar seed={seed} image={image} size={size} priority={priority} className={className} />
}

interface TeamAvatarProps {
  name?: string | null
  id?: string | null
  image?: string | null
  size?: number
  priority?: boolean
  className?: string
}

export const TeamAvatar = ({ name, id, image, size = 24, priority, className }: TeamAvatarProps) => {
  const seed = name || id

  if (!seed) return <div style={{ width: size, height: size }} />

  return <SeededAvatar seed={seed} image={image} size={size} priority={priority} className={className} />
}
